export class ForgeProjectRelation {
    constructor(model) {
        this.id = model.id;
        this.sourceItemId = model.sourceItemId;
        this.sourceItemType = model.sourceItemType;
        this.targetItemId = model.targetItemId;
        this.targetItemType = model.targetItemType;
        this.createdAt = new Date(model.createdAt);
        this.projectId = model.projectId;
    }
    toRemote() {
        return Object.assign(Object.assign({}, this), { createdAt: this.createdAt.toISOString() });
    }
}
